var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowOn = function SvgArrowOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#EBF7FF",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0078FF",
    strokeWidth: 1.333,
    d: "m10 8.333 4 3.834L10 16"
  })));
};
export default SvgArrowOn;